// src/components/BlogSection.js

import React from 'react';
import { Link } from 'react-router-dom';
import './BlogSection.css';

export default function BlogSection({ posts }) {
  console.log("📰 BlogSection received posts prop:", posts);

  // 1) still fetching
  if (posts === null) {
    return (
      <section className="blogSection">
        <h2 className="blogSectionTitle">Latest from Nexed Insights</h2>
        <p className="blogSectionLoading">Loading latest posts…</p>
      </section>
    );
  }

  // 2) fetched, but none available
  if (Array.isArray(posts) && posts.length === 0) {
    return (
      <section className="blogSection">
        <p className="blogSectionLoading">
          No posts available right now—check back soon!
        </p>
      </section>
    );
  }

  // 3) we have posts
  return (
    <section className="blogSection">
      <div className="blogGrid">
        {posts.map((post) => (
          <article key={post.id} className="blogCard">
            <Link to={`/blog/${post.slug}`} className="blogImageLink">
              {post.imageUrl ? (
                <img
                  src={post.imageUrl}
                  alt={post.title}
                  className="blogImage"
                />
              ) : (
                <div className="blogImagePlaceholder" />
              )}
            </Link>
            <div className="blogContent">
              <p className="blogDate">{post.date}</p>
              <h3 className="blogTitle">{post.title}</h3>
              <p className="blogSummary">{post.summary}</p>
              <Link to={`/blog/${post.slug}`} className="readMoreLink">
                Read more <i className="fa-regular fa-arrow-right" />
              </Link>
            </div>
          </article>
        ))}
      </div>
    </section>
  );
}